import { BadgeCheck, Ruler, Handshake } from "lucide-react";
import Reveal from "@/components/Reveal";

const highlights = [
  {
    icon: BadgeCheck,
    title: "Quality Execution",
    text: "Professional workmanship and attention to finishing.",
  },
  {
    icon: Ruler,
    title: "Detail Driven",
    text: "Careful planning and precise execution.",
  },
  {
    icon: Handshake,
    title: "Complete Project Support",
    text: "From initial discussion to final finishing.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24">
        <Reveal>
        <div>
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-zinc-500 mb-5">
            01 &middot; Saurabh Decor Creations
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-zinc-950 leading-tight">
            Built with Precision. Designed with Purpose.
          </h2>
        </div>
        </Reveal>
        <div>
          <p className="text-base lg:text-lg leading-relaxed text-zinc-600">
            Saurabh Decor Creations provides reliable civil, interior, modular kitchen and
            restoration &amp; renovation solutions for residential and commercial spaces in
            Mumbai. Every project is approached with careful planning, honest coordination
            and a commitment to clean, lasting finishes.
          </p>
          <div className="mt-12 divide-y divide-zinc-200 border-y border-zinc-200">
            {highlights.map((h, i) => (
              <Reveal key={h.title} delay={i * 0.1}>
              <div className="flex items-start gap-6 py-7" data-testid={`about-highlight-${h.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <h.icon className="w-7 h-7 text-zinc-950 shrink-0 mt-0.5" strokeWidth={1.25} />
                <div>
                  <h3 className="font-heading text-xl font-medium text-zinc-950">{h.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-zinc-600">{h.text}</p>
                </div>
              </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
